// extracted by mini-css-extract-plugin
export default {"container":"G19GQdSZiXeSwjLujgXV","box":"w6KY5J2AJslz0H2XuVlX"};